module.exports = __webpack_public_path__ + "img/document.91a1d167.svg";